// extracted by mini-css-extract-plugin
export default {"wrapper":"D9Gb46Vusuc87caVXZ1W","label":"ffnP0084v0ygtcjF_vjF"};